// extracted by mini-css-extract-plugin
export default {"spinner":"IconButton_spinner__6mG4D","draai":"IconButton_draai__Coix+"};